const options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      revision: '2024-06-15',
      Authorization: 'Klaviyo-API-Key pk_1aee1eb862b4d2c5fcab3a8eb0fc323c15'
    }
  }
const API_GATEWAY_URL = "https://ixqz11yn9d.execute-api.ca-central-1.amazonaws.com"

function fetchProfileFromId(id) {
    const url = `${API_GATEWAY_URL}/profiles/${id}`

    return fetch(url, options)
      .then(response => response.json())
      .catch(err => console.error(err))
  }

function fetchIdFromEmail(email) {
    const url = `${API_GATEWAY_URL}/profiles/?filter=equals(email%2C"${email}")`

    return fetch(url, options)
      .then(response => response.json())
      .catch(err => console.error(err))
}

export async function fetchReferralLinkFromEmail(email) {
    try {
      const fetchIdResponse = await fetchIdFromEmail(email)
      const id = fetchIdResponse.data[0].id

      const fetchProfileResponse = await fetchProfileFromId(id)
      const profile = fetchProfileResponse.data.attributes.properties

      let referralLink = profile["Referral Link - SocialSnowball"]
      return referralLink
    } catch (error) {
      console.error(error)
      return null
    }
  }